import travelCase from "../images/travel-case.png";

export const newsletterOffers = {
  travelCase: {
    title: "Free Travel Case",
    description:
      "Subscribe to the Neurosity newsletter to get a free Travel Case when you buy your first Crown.",
    image: travelCase,
    cta: "Claim offer",
    contentfulEntryId: "Th1tXExrbcMYH7uaZtcUF"
  },
  discount: {
    title: "$100 off your Crown",
    description:
      "Subscribe to the Neurosity newsletter to receive $100 off when you buy your first Crown.",
    image: null,
    cta: "Claim offer",
    contentfulEntryId: "1NuM05oblUhLjabDaFTcz8"
  },
  discountV2: {
    title: "10% off your Crown",
    description:
      "Subscribe to the Neurosity newsletter to receive a 10% off discount code.",
    image: null,
    cta: "Claim offer",
    contentfulEntryId: "1JG6ifVbzLfm5qiUJh7Mhh"
  },
  freeShipping: {
    title: "Free Shipping",
    description:
      "Subscribe to the Neurosity newsletter to get Free Shipping when you buy your first Crown.",
    image: null,
    cta: "Claim offer",
    contentfulEntryId: "5VlEkPCGdhpOP0P8qTp6yu"
  }
};
